// Mock Data for API Simulation
// This file contains mock JSON objects to simulate API calls

// API Response Helpers
export const createApiResponse = (data, success = true, message = "") => ({
  success,
  data,
  message,
  timestamp: new Date().toISOString()
});

// Simulate API delay
export const simulateApiDelay = (ms = 1000) =>
  new Promise(resolve => setTimeout(resolve, ms));

export const mockApiData = {
  // User Authentication
  auth: {
    login: {
      success: {
        user: {
          id: 1,
          email: "user@example.com",
          firstName: "John",
          lastName: "Doe",
          avatar: "/images/personIco.png",
          role: "user",
          isActive: true,
          lastLogin: "2025-08-28T10:30:00Z",
          homeownerId: 1,
          homeowner: {
            homeownerId: 1,
            homeownerName: "John's Home",
            homeNumber: 1,
            suburbId: 1,
            suburb: {
              suburbId: 1,
              suburbName: "Downtown"
            }
          }
        },
        token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...",
        refreshToken: "refresh_token_here",
        expiresIn: 3600
      },
      error: {
        message: "Invalid credentials",
        code: "INVALID_CREDENTIALS",
        statusCode: 401
      }
    },
    loginAdmin: {
      success: {
        user: {
          id: 2,
          email: "admin.demo@gmail.com",
          firstName: "Admin",
          lastName: "Manager",
          avatar: "/images/admin.svg",
          role: "admin",
          isActive: true,
          lastLogin: "2025-08-28T10:30:00Z",
          homeownerId: null,
          homeowner: null,
          permissions: [
            "manage_owners",
            "manage_payments", 
            "manage_amenities",
            "view_reports",
            "manage_settings",
            "manage_reservations",
            "view_analytics"
          ]
        },
        token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9admin...",
        refreshToken: "admin_refresh_token_here",
        expiresIn: 3600
      }
    },
    register: {
      success: {
        user: {
          id: 2,
          email: "newuser@example.com",
          firstName: "Jane",
          lastName: "Smith",
          avatar: null,
          role: "user",
          isActive: false,
          createdAt: "2025-08-28T10:30:00Z"
        },
        message: "Registration successful. Please verify your email."
      }
    },
    getProfile: {
      success: {
        user: {
          id: 1,
          email: "user@example.com",
          firstName: "John",
          lastName: "Doe",
          avatar: "/images/personIco.png",
          role: "user",
          isActive: true,
          lastLogin: "2025-08-28T10:30:00Z",
          homeownerId: 1,
          homeowner: {
            homeownerId: 1,
            homeownerName: "John's Home",
            homeNumber: 1,
            suburbId: 1,
            suburb: {
              suburbId: 1,
              suburbName: "Downtown"
            }
          }
        },
        token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...",
        refreshToken: "refresh_token_here",
        expiresIn: 3600
      }
    }
  },

  // --- Visitor Mock Data ---
  visitorApi: {
    getVisitorsByHome: {
      success: {
        visitors: [
          {
            visitorId: 1,
            visitorName: "Josue Wal",
            visitorPhoneNumber: "+523325646932",
            visitReason: "Visita",
            startDate: "2025-08-28T09:00:00Z",
            endDate: "2025-08-28T11:00:00Z",
            unlimitedAccess: false,
            maxOpenDoorTimes: 3,
            isGroup: false,
            useVehicle: true,
            placas: "ABC123",
            color: "Red",
            marca: "Toyota",
            comentario: "No comments",
            invitationStatusId: 1,
            invitationStatus: {
              invitationStatusId: 1,
              statusName: "Pending"
            },
            homeownerId: 1,
            homeowner: {
              homeownerId: 1,
              homeownerName: "John's Home",
              homeNumber: 1,
              suburbId: 1,
              suburb: {
                suburbId: 1,
                suburbName: "Downtown"
              }
            },
            guid: "e7b8a2c2-4f3d-4e6a-9b1a-2c5f8d7e9a1b"
          },
          {
            visitorId: 2,
            visitorName: "Bob Green",
            visitorPhoneNumber: "+523325646932",
            visitReason: "Visita",
            startDate: "2025-08-28T09:00:00Z",
            endDate: "2025-08-28T11:00:00Z",
            unlimitedAccess: false,
            maxOpenDoorTimes: 3,
            isGroup: false,
            useVehicle: true,
            placas: "ABC123",
            color: "Red",
            marca: "Toyota",
            comentario: "No comments",
            invitationStatusId: 1,
            invitationStatus: {
              invitationStatusId: 1,
              statusName: "Pending"
            },
            homeownerId: 1,
            homeowner: {
              homeownerId: 1,
              homeownerName: "John's Home",
              homeNumber: 1,
              suburbId: 1,
              suburb: {
                suburbId: 1,
                suburbName: "Downtown"
              }
            },
            guid: "e7b8a2c2-4f3d-4e6a-9b1a-2c5f8d7e9a1b"
          },
          {
            visitorId: 3,
            visitorName: "Charlie Johnson",
            visitorPhoneNumber: "+523325646932",
            visitReason: "Visita",
            startDate: "2025-08-28T09:00:00Z",
            endDate: "2025-08-28T11:00:00Z",
            unlimitedAccess: false,
            maxOpenDoorTimes: 3,
            isGroup: false,
            useVehicle: true,
            placas: "ABC123",
            color: "Red",
            marca: "Toyota",
            comentario: "No comments",
            invitationStatusId: 1,
            invitationStatus: {
              invitationStatusId: 1,
              statusName: "Pending"
            },
            homeownerId: 1,
            homeowner: {
              homeownerId: 1,
              homeownerName: "John's Home",
              homeNumber: 1,
              suburbId: 1,
              suburb: {
                suburbId: 1,
                suburbName: "Downtown"
              }
            },
            guid: "e7b8a2c2-4f3d-4e6a-9b1a-2c5f8d7e9a1b"
          },
          {
            visitorId: 4,
            visitorName: "Bob Green",
            visitorPhoneNumber: "+523325646932",
            visitReason: "Visita",
            startDate: "2025-08-28T09:00:00Z",
            endDate: "2025-08-28T11:00:00Z",
            unlimitedAccess: false,
            maxOpenDoorTimes: 3,
            isGroup: false,
            useVehicle: true,
            placas: "ABC123",
            color: "Red",
            marca: "Toyota",
            comentario: "No comments",
            invitationStatusId: 1,
            invitationStatus: {
              invitationStatusId: 1,
              statusName: "Pending"
            },
            homeownerId: 1,
            homeowner: {
              homeownerId: 1,
              homeownerName: "John's Home",
              homeNumber: 1,
              suburbId: 1,
              suburb: {
                suburbId: 1,
                suburbName: "Downtown"
              }
            },
            guid: "e7b8a2c2-4f3d-4e6a-9b1a-2c5f8d7e9a1b"
          },
          {
            visitorId: 5,
            visitorName: "Alice Brown",
            visitorPhoneNumber: "+523325646932",
            visitReason: "Visita",
            startDate: "2025-08-28T09:00:00Z",
            endDate: "2025-08-28T11:00:00Z",
            unlimitedAccess: false,
            maxOpenDoorTimes: 3,
            isGroup: false,
            useVehicle: true,
            placas: "ABC123",
            color: "Red",
            marca: "Toyota",
            comentario: "No comments",
            invitationStatusId: 3,
            invitationStatus: {
              invitationStatusId: 3,
              statusName: "Accepted"
            },
            homeownerId: 1,
            homeowner: {
              homeownerId: 1,
              homeownerName: "John's Home",
              homeNumber: 1,
              suburbId: 1,
              suburb: {
                suburbId: 1,
                suburbName: "Downtown"
              }
            },
            guid: "e7b8a2c2-4f3d-4e6a-9b1a-2c5f8d7e9a1b"
          },
          {
            visitorId: 6,
            visitorName: "Carlos Slim",
            visitorPhoneNumber: "+523325646932",
            visitReason: "Visita",
            startDate: "2025-08-28T09:00:00Z",
            endDate: "2025-08-28T11:00:00Z",
            unlimitedAccess: false,
            maxOpenDoorTimes: 3,
            isGroup: false,
            useVehicle: true,
            placas: "ABC123",
            color: "Red",
            marca: "Toyota",
            comentario: "No comments",
            invitationStatusId: 3,
            invitationStatus: {
              invitationStatusId: 3,
              statusName: "Accepted"
            },
            homeownerId: 1,
            homeowner: {
              homeownerId: 1,
              homeownerName: "John's Home",
              homeNumber: 1,
              suburbId: 1,
              suburb: {
                suburbId: 1,
                suburbName: "Downtown"
              }
            },
            guid: "e7b8a2c2-4f3d-4e6a-9b1a-2c5f8d7e9a1b"
          },
          {
            visitorId: 7,
            visitorName: "Jeff Bezos",
            visitorPhoneNumber: "+523325646932",
            visitReason: "Visita",
            startDate: "2025-08-28T09:00:00Z",
            endDate: "2025-08-28T11:00:00Z",
            unlimitedAccess: false,
            maxOpenDoorTimes: 3,
            isGroup: false,
            useVehicle: true,
            placas: "ABC123",
            color: "Red",
            marca: "Toyota",
            comentario: "No comments",
            invitationStatusId: 3,
            invitationStatus: {
              invitationStatusId: 3,
              statusName: "Accepted"
            },
            homeownerId: 1,
            homeowner: {
              homeownerId: 1,
              homeownerName: "John's Home",
              homeNumber: 1,
              suburbId: 1,
              suburb: {
                suburbId: 1,
                suburbName: "Downtown"
              }
            },
            guid: "e7b8a2c2-4f3d-4e6a-9b1a-2c5f8d7e9a1b"
          },
          {
            visitorId: 8,
            visitorName: "Elon Musk",
            visitorPhoneNumber: "+523325646932",
            visitReason: "Visita",
            startDate: "2025-08-28T09:00:00Z",
            endDate: "2025-08-28T11:00:00Z",
            unlimitedAccess: false,
            maxOpenDoorTimes: 3,
            isGroup: false,
            useVehicle: true,
            placas: "ABC123",
            color: "Red",
            marca: "Toyota",
            comentario: "No comments",
            invitationStatusId: 2,
            invitationStatus: {
              invitationStatusId: 2,
              statusName: "Expired"
            },
            homeownerId: 1,
            homeowner: {
              homeownerId: 1,
              homeownerName: "John's Home",
              homeNumber: 1,
              suburbId: 1,
              suburb: {
                suburbId: 1,
                suburbName: "Downtown"
              }
            },
            guid: "e7b8a2c2-4f3d-4e6a-9b1a-2c5f8d7e9a1b"
          },
          {
            visitorId: 9,
            visitorName: "Mark Zuckerberg",
            visitorPhoneNumber: "+523325646932",
            visitReason: "Visita",
            startDate: "2025-08-28T09:00:00Z",
            endDate: "2025-08-28T11:00:00Z",
            unlimitedAccess: false,
            maxOpenDoorTimes: 3,
            isGroup: false,
            useVehicle: true,
            placas: "ABC123",
            color: "Red",
            marca: "Toyota",
            comentario: "No comments",
            invitationStatusId: 2,
            invitationStatus: {
              invitationStatusId: 2,
              statusName: "Expired"
            },
            homeownerId: 1,
            homeowner: {
              homeownerId: 1,
              homeownerName: "John's Home",
              homeNumber: 1,
              suburbId: 1,
              suburb: {
                suburbId: 1,
                suburbName: "Downtown"
              }
            },
            guid: "e7b8a2c2-4f3d-4e6a-9b1a-2c5f8d7e9a1b"
          },
          {
            visitorId: 10,
            visitorName: "Bill Gates",
            visitorPhoneNumber: "+523325646932",
            visitReason: "Inquilino",
            startDate: "2025-08-28T09:00:00Z",
            endDate: "2025-08-28T11:00:00Z",
            unlimitedAccess: false,
            maxOpenDoorTimes: 3,
            isGroup: false,
            useVehicle: true,
            placas: "ABC123",
            color: "Red",
            marca: "Toyota",
            comentario: "No comments",
            invitationStatusId: 2,
            invitationStatus: {
              invitationStatusId: 2,
              statusName: "Expired"
            },
            homeownerId: 1,
            homeowner: {
              homeownerId: 1,
              homeownerName: "John's Home",
              homeNumber: 1,
              suburbId: 1,
              suburb: {
                suburbId: 1,
                suburbName: "Downtown"
              }
            },
            guid: "e7b8a2c2-4f3d-4e6a-9b1a-2c5f8d7e9a1b"
          },
          {
            visitorId: 11,
            visitorName: "Robert Johnson",
            visitorPhoneNumber: "+523325646932",
            visitReason: "Proveedor",
            startDate: "2025-08-28T09:00:00Z",
            endDate: "2025-08-28T11:00:00Z",
            unlimitedAccess: false,
            maxOpenDoorTimes: 3,
            isGroup: false,
            useVehicle: true,
            placas: "ABC123",
            color: "Red",
            marca: "Toyota",
            comentario: "No comments",
            invitationStatusId: 2,
            invitationStatus: {
              invitationStatusId: 2,
              statusName: "Expired"
            },
            homeownerId: 1,
            homeowner: {
              homeownerId: 1,
              homeownerName: "John's Home",
              homeNumber: 1,
              suburbId: 1,
              suburb: {
                suburbId: 1,
                suburbName: "Downtown"
              }
            },
            guid: "e7b8a2c2-4f3d-4e6a-9b1a-2c5f8d7e9a1b"
          },
          {
            visitorId: 12,
            visitorName: "Charles Smith",
            visitorPhoneNumber: "+523325646932",
            visitReason: "Visita",
            startDate: "2025-08-28T09:00:00Z",
            endDate: "2025-08-28T11:00:00Z",
            unlimitedAccess: false,
            maxOpenDoorTimes: 3,
            isGroup: false,
            useVehicle: true,
            placas: "ABC123",
            color: "Red",
            marca: "Toyota",
            comentario: "No comments",
            invitationStatusId: 2,
            invitationStatus: {
              invitationStatusId: 2,
              statusName: "Expired"
            },
            homeownerId: 1,
            homeowner: {
              homeownerId: 1,
              homeownerName: "John's Home",
              homeNumber: 1,
              suburbId: 1,
              suburb: {
                suburbId: 1,
                suburbName: "Downtown"
              }
            },
            guid: "e7b8a2c2-4f3d-4e6a-9b1a-2c5f8d7e9a1b"
          },
          {
            visitorId: 13,
            visitorName: "Jeniffer Williams",
            visitorPhoneNumber: "+523325646932",
            visitReason: "Visita",
            startDate: "2025-08-28T09:00:00Z",
            endDate: "2025-08-28T11:00:00Z",
            unlimitedAccess: false,
            maxOpenDoorTimes: 3,
            isGroup: false,
            useVehicle: true,
            placas: "ABC123",
            color: "Red",
            marca: "Toyota",
            comentario: "No comments",
            invitationStatusId: 3,
            invitationStatus: {
              invitationStatusId: 3,
              statusName: "Accepted"
            },
            homeownerId: 1,
            homeowner: {
              homeownerId: 1,
              homeownerName: "John's Home",
              homeNumber: 1,
              suburbId: 1,
              suburb: {
                suburbId: 1,
                suburbName: "Downtown"
              }
            },
            guid: "e7b8a2c2-4f3d-4e6a-9b1a-2c5f8d7e9a1b"
          }
        ]
      },
      error: {
        message: "Invalid credentials",
        code: "INVALID_CREDENTIALS",
        statusCode: 401
      }
    },
    createVisitor: {
      success: {
        visitor:
        {
          visitorId: 100,
          visitorName: "Alice Brown",
          visitorPhoneNumber: "+523325646932",
          visitReason: "Visita",
          startDate: "2025-08-28T09:00:00Z",
          endDate: "2025-08-28T11:00:00Z",
          unlimitedAccess: false,
          maxOpenDoorTimes: 3,
          isGroup: false,
          useVehicle: true,
          placas: "ABC123",
          color: "Red",
          marca: "Toyota",
          comentario: "No comments",
          invitationStatusId: 1,
          invitationStatus: {
            invitationStatusId: 1,
            statusName: "Pending"
          },
          homeownerId: 1,
          homeowner: {
            homeownerId: 1,
            homeownerName: "John's Home",
            homeNumber: 1,
            suburbId: 1,
            suburb: {
              suburbId: 1,
              suburbName: "Downtown"
            }
          },
          guid: "e7b8a2c2-4f3d-4e6a-9b1a-2c5f8d7e9a1b"
        },
      },
      error: {
        message: "Invalid credentials",
        code: "INVALID_CREDENTIALS",
        statusCode: 401
      }
    },
    getVisitorByGuid: {
      success: {
        visitor: {
          visitorId: 5,
          visitorName: "Alice Brown",
          visitorPhoneNumber: "+523325646932",
          visitReason: "Visita",
          startDate: "2025-08-28T09:00:00Z",
          endDate: "2025-08-28T11:00:00Z",
          unlimitedAccess: false,
          maxOpenDoorTimes: 3,
          isGroup: false,
          useVehicle: true,
          placas: "ABC123",
          color: "Red",
          marca: "Toyota",
          comentario: "No comments",
          invitationStatusId: 1,
          invitationStatus: {
            invitationStatusId: 1,
            statusName: "Pending"
          },
          homeownerId: 1,
          homeowner: {
            homeownerId: 1,
            homeownerName: "John's Home",
            homeNumber: 1,
            suburbId: 1,
            suburb: {
              suburbId: 1,
              suburbName: "Downtown"
            }
          },
            guid: "e7b8a2c2-4f3d-4e6a-9b1a-2c5f8d7e9a1b"
        }
      },
      error: {
        message: "Invalid credentials",
        code: "INVALID_CREDENTIALS",
        statusCode: 401
      }
    }
  },

  // Testimonials Data
  testimonials: [
    {
      id: 1,
      name: "Sarah Johnson",
      position: "CEO at TechCorp",
      company: "TechCorp Inc.",
      avatar: "/images/testimonial-1.jpg",
      rating: 5,
      text: "This platform has revolutionized how we handle our business operations. The interface is intuitive and the results speak for themselves.",
      date: "2025-08-15T00:00:00Z",
      featured: true
    },
    {
      id: 2,
      name: "Michael Chen",
      position: "Marketing Director",
      company: "Growth Dynamics",
      avatar: "/images/testimonial-2.jpg",
      rating: 5,
      text: "Outstanding service and support. Our team productivity increased by 40% since we started using this solution.",
      date: "2025-08-10T00:00:00Z",
      featured: true
    },
    {
      id: 3,
      name: "Emily Rodriguez",
      position: "Founder",
      company: "StartupX",
      avatar: "/images/testimonial-3.jpg",
      rating: 4,
      text: "Great value for money. The features are comprehensive and the customer support is top-notch.",
      date: "2025-08-05T00:00:00Z",
      featured: false
    }
  ],

  announcements: [
    {
      id: 1,
      title: "Aviso de ConexaHome!!",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.  Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      featured: true,
      author: "Product Team",
      imageSrc: "https://images.unsplash.com/photo-1616113364365-b6013f3dad25?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      category: "Travel Guide",
      date: "April 19, 2020"
    },
    {
      id: 2,
      title: "Avance de Proyecto",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.  Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      featured: true,
      author: "Admin",
      imageSrc: "https://images.unsplash.com/photo-1616113364365-b6013f3dad25?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      category: "Travel Guide",
      date: "April 20, 2020"
    },
    {
      id: 3,
      title: "Recordatorio de Corte de Agua!!",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.  Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      featured: false,
      author: "Admin",
      imageSrc: "https://images.unsplash.com/photo-1616113364365-b6013f3dad25?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      category: "Travel Guide",
      date: "April 20, 2020"
    },
    {
      id: 4,
      title: "Aviso de Mantenimiento Alberca!!",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.  Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      featured: true,
      author: "Admin",
      imageSrc: "https://images.unsplash.com/photo-1616113364365-b6013f3dad25?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      category: "Travel Guide",
      date: "April 20, 2020"
    },
    {
      id: 5,
      title: "Recordatorio Junta Vecinal",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.  Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      featured: true,
      author: "Admin",
      imageSrc: "https://images.unsplash.com/photo-1616113364365-b6013f3dad25?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      category: "Travel Guide",
      date: "April 20, 2020"
    },
    {
      id: 6,
      title: "Seguimiento Incidente de Auto",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.  Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      featured: true,
      author: "Admin",
      imageSrc: "https://images.unsplash.com/photo-1616113364365-b6013f3dad25?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      category: "Travel Guide",
      date: "April 20, 2020"
    },
    {
      id: 7,
      title: "Invitación a Curso para Niños",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.  Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      featured: true,
      author: "Admin",
      imageSrc: "https://images.unsplash.com/photo-1616113364365-b6013f3dad25?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      category: "Travel Guide",
      date: "April 20, 2020"
    },
    {
      id: 8,
      title: "Rifa Viaje a Cancún",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.  Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      featured: true,
      author: "Product Team",
      imageSrc: "https://images.unsplash.com/photo-1616113364365-b6013f3dad25?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      category: "Travel Guide",
      date: "April 19, 2020"
    },
    {
      id: 9,
      title: "Reporte de Empresa de Seguridad",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.  Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      featured: true,
      author: "Admin",
      imageSrc: "https://images.unsplash.com/photo-1616113364365-b6013f3dad25?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      category: "Travel Guide",
      date: "April 20, 2020"
    },
    {
      id: 10,
      title: "Reporte Trimestral de Contabilidad",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.  Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      featured: true,
      author: "Admin",
      imageSrc: "https://images.unsplash.com/photo-1616113364365-b6013f3dad25?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      category: "Travel Guide",
      date: "April 20, 2020"
    },
    {
      id: 11,
      title: "Recordatorio Fumigación!",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.  Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      featured: false,
      author: "Admin",
      imageSrc: "https://images.unsplash.com/photo-1616113364365-b6013f3dad25?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      category: "Travel Guide",
      date: "April 20, 2020"
    }
  ],

  amenitiesApi: {
    getAmenitiesByHome: [
      {
        id: 1,
        type: "Alberca",
        createdDate: "25/06/2024",
        hour: "10:00-12:00",
        status: 0,
      },
      {
        id: 2,
        type: "Terraza",
        createdDate: "25/06/2024",
        hour: "10:00-12:00",
        status: 1,
      },
      {
        id: 3,
        type: "Gimnasio",
        createdDate: "25/06/2024",
        hour: "10:00-12:00",
        status: 1,
      },
      {
        id: 4,
        type: "Asador",
        createdDate: "25/06/2024",
        hour: "10:00-12:00",
        status: 1,
      },
      {
        id: 5,
        type: "Alberca",
        createdDate: "25/06/2024",
        hour: "10:00-12:00",
        status: 1,
      }
    ],
    getAmenitiesPreferences: {
      amenities: [
        {
          id: 1,
          name: "Alberca",
          image: "images/demo/swimming-pool.png",
          description: "Alberca de uso común.",
          rules: ["No comida", "No mascotas", "Traje de baño obligatorio."],
          cost: 0
        },
        {
          id: 2,
          name: "Terraza",
          image: "images/demo/terrace.png",
          description: "Terraza para eventos.",
          rules: ["Horario 10-22h", "Limpieza obligatoria."],
          cost: 1000
        },
        {
          id: 3,
          name: "Asador",
          image: "images/demo/grill.png",
          description: "Asador para eventos.",
          rules: ["Horario 10-22h", "Limpieza obligatoria."],
          cost: 250
        },
        {
          id: 4,
          name: "Gimnasio",
          image: "images/demo/gym.png",
          description: "Gimnasio de uso común.",
          rules: ["Horario 6-22h", "Uso exclusivo para residentes", "Uso de toalla obligatoria."],
          cost: 0
        }
      ],
      slots: [
        { value: 1, label: 'Entre Semana' },
        { value: 2, label: 'Sábado' },
        { value: 3, label: 'Domingo' }
      ],
      availablesHours: [
        { value: 1, label: "10:00 - 12:00" },
        { value: 2, label: "12:00 - 14:00" },
        { value: 3, label: "14:00 - 16:00" },
        { value: 4, label: "16:00 - 18:00" },
        { value: 5, label: "18:00 - 20:00" },
        { value: 6, label: "20:00 - 22:00" }
      ]
    },
    reservations: [
      {
        id: 1,
        amenity: "Alberca",
        user: "Ana Perez",
        house: "1",
        date: "2025-10-15",
        time: "10:00-12:00",
        isPay: true,
        status: 0 // 0: pendiente, 1: aprobado, 2: rechazado
      },
      {
        id: 2,
        amenity: "Terraza",
        user: "Luis Gomez",
        house: "12",
        date: "2025-10-16",
        time: "16:00-20:00",
        isPay: false,
        status: 1
      },
      {
        id: 3,
        amenity: "Asador",
        user: "Luis Alberto Mtz",
        house: "3",
        date: "2025-10-17",
        time: "10:00-12:00",
        isPay: true,
        status: 0
      },
      {
        id: 4,
        amenity: "Asador",
        user: "Josue Martinez",
        house: "4",
        date: "2025-10-18",
        time: "16:00-20:00",
        isPay: false,
        status: 1
      },
      {
        id: 5,
        amenity: "Gimnasio",
        user: "Maria Rodriguez",
        house: "7",
        date: "2025-10-19",
        time: "08:00-10:00",
        isPay: true,
        status: 2
      }
    ],
    getReservedAmenitiesByType:
    [[
        { date: "2025-09-11", hours: [1, 2, 3, 4, 5, 6] },
        { date: "2025-09-12", hours: [1, 2, 3] },
        { date: "2025-09-18", hours: [1, 2, 3, 4, 5, 6] },
        { date: "2025-09-26", hours: [1, 2, 3, 4, 5, 6] }
      ],
      [
        { date: "2025-09-16", hours: [1, 2, 3, 4, 5, 6] },
        { date: "2025-09-21", hours: [1, 2, 3] },
        { date: "2025-09-27", hours: [4, 5, 6] }
      ]],
    reserveAmenity: {
      id: 8,
      type: "Terraza",
      createdDate: "25/09/2025",
      hour: "10:00-12:00",
      status: 0
    }
  },

  // Pricing Plans
  pricing: [
    {
      id: 1,
      name: "Basic",
      price: 29,
      currency: "USD",
      interval: "month",
      description: "Perfect for small teams getting started",
      features: [
        "Up to 5 team members",
        "10GB storage",
        "Basic analytics",
        "Email support",
        "Standard templates"
      ],
      highlighted: false,
      popular: false,
      buttonText: "Get Started",
      trialDays: 14
    },
    {
      id: 2,
      name: "Professional",
      price: 79,
      currency: "USD",
      interval: "month",
      description: "Best for growing businesses",
      features: [
        "Up to 25 team members",
        "100GB storage",
        "Advanced analytics",
        "Priority support",
        "Custom templates",
        "API access",
        "Advanced integrations"
      ],
      highlighted: true,
      popular: true,
      buttonText: "Start Free Trial",
      trialDays: 14
    },
    {
      id: 3,
      name: "Enterprise",
      price: 199,
      currency: "USD",
      interval: "month",
      description: "For large organizations with advanced needs",
      features: [
        "Unlimited team members",
        "Unlimited storage",
        "Enterprise analytics",
        "24/7 phone support",
        "White-label solution",
        "Custom integrations",
        "Dedicated account manager",
        "Advanced security features"
      ],
      highlighted: false,
      popular: false,
      buttonText: "Contact Sales",
      trialDays: 30
    }
  ],

  // Blog Posts
  blog: [
    {
      id: 1,
      title: "10 Tips for Better Business Management",
      slug: "10-tips-better-business-management",
      excerpt: "Discover proven strategies to streamline your business operations and boost productivity.",
      content: "Full blog content would go here...",
      featuredImage: "/images/blog-1.jpg",
      author: {
        name: "Alex Thompson",
        avatar: "/images/author-1.jpg",
        bio: "Business consultant with 10+ years of experience"
      },
      category: "Business",
      tags: ["management", "productivity", "business"],
      publishedAt: "2025-08-20T00:00:00Z",
      readingTime: 5,
      views: 1250,
      featured: true
    },
    {
      id: 2,
      title: "The Future of Remote Work",
      slug: "future-of-remote-work",
      excerpt: "Exploring how remote work is reshaping the business landscape.",
      content: "Full blog content would go here...",
      featuredImage: "/images/blog-2.jpg",
      author: {
        name: "Maria Garcia",
        avatar: "/images/author-2.jpg",
        bio: "Remote work specialist and HR consultant"
      },
      category: "Workplace",
      tags: ["remote-work", "future", "technology"],
      publishedAt: "2025-08-18T00:00:00Z",
      readingTime: 7,
      views: 980,
      featured: false
    }
  ],

  // FAQ Data
  faqs: [
    {
      id: 1,
      question: "How do I get started?",
      answer: "Getting started is easy! Simply sign up for a free account, choose your plan, and follow our step-by-step onboarding process.",
      category: "Getting Started",
      order: 1
    },
    {
      id: 2,
      question: "What payment methods do you accept?",
      answer: "We accept all major credit cards (Visa, MasterCard, American Express), PayPal, and bank transfers for enterprise accounts.",
      category: "Billing",
      order: 2
    },
    {
      id: 3,
      question: "Can I cancel my subscription anytime?",
      answer: "Yes, you can cancel your subscription at any time. There are no cancellation fees, and you'll continue to have access until the end of your billing period.",
      category: "Billing",
      order: 3
    },
    {
      id: 4,
      question: "Is my data secure?",
      answer: "Absolutely. We use enterprise-grade security measures including SSL encryption, regular security audits, and compliance with industry standards.",
      category: "Security",
      order: 4
    }
  ],

  // Features Data
  features: [
    {
      id: 1,
      title: "Easy Integration",
      description: "Seamlessly integrate with your existing tools and workflows",
      icon: "/images/customize-icon.svg",
      category: "Integration"
    },
    {
      id: 2,
      title: "Advanced Analytics",
      description: "Get detailed insights into your business performance",
      icon: "/images/stats-illustration.svg",
      category: "Analytics"
    },
    {
      id: 3,
      title: "24/7 Support",
      description: "Our expert team is available around the clock to help you",
      icon: "/images/support-icon.svg",
      category: "Support"
    },
    {
      id: 4,
      title: "Secure & Reliable",
      description: "Enterprise-grade security with 99.9% uptime guarantee",
      icon: "/images/shield-icon.svg",
      category: "Security"
    }
  ],

  // Contact Form Submissions
  contact: {
    submit: {
      success: {
        message: "Thank you for your message! We'll get back to you within 24 hours.",
        id: "contact_12345",
        timestamp: "2025-08-28T10:30:00Z"
      },
      error: {
        message: "Failed to send message. Please try again later.",
        code: "SUBMISSION_ERROR",
        statusCode: 500
      }
    }
  },

  // Newsletter Subscription
  newsletter: {
    subscribe: {
      success: {
        message: "Successfully subscribed to our newsletter!",
        email: "user@example.com",
        subscribed: true,
        timestamp: "2025-08-28T10:30:00Z"
      },
      error: {
        message: "This email is already subscribed.",
        code: "ALREADY_SUBSCRIBED",
        statusCode: 409
      }
    }
  },

  // Company Stats/Metrics
  stats: {
    customers: 10000,
    projects: 50000,
    countries: 120,
    satisfaction: 98,
    uptime: 99.9,
    support_tickets_resolved: 15000
  }
};
// --- Payment Mock Data ---
mockApiData.paymentApi = {
  getPaymentsByHome: {
    success: {
      payments: [
        {
          paymentId: 1,
          house: "101",
          ownerName: "John Doe",
          category: "Mantenimiento",
          createdDate: "2025-08-01",
          balance: 1200,
          referenceNumber: "000001",
          status: 1 // 0: En proceso, 1: Pagado, 2: Pendiente
        },
        {
          paymentId: 2,
          house: "101",
          ownerName: "John Doe",
          category: "Agua",
          createdDate: "2025-08-10",
          balance: 350,
          referenceNumber: "000002",
          status: 0
        },
        {
          paymentId: 3,
          category: "Luz",
          house: "101",
          ownerName: "John Doe",
          createdDate: "2025-08-15",
          balance: 500,
          referenceNumber: "",
          status: 2
        },
        {
          paymentId: 4,
          house: "101",
          ownerName: "John Doe",
          category: "Mantenimiento",
          createdDate: "2025-08-01",
          balance: 1200,
          referenceNumber: "000004",
          status: 1
        },
        {
          paymentId: 5,
          house: "101",
          ownerName: "John Doe",
          category: "Mantenimiento",
          createdDate: "2025-08-15",
          balance: 500,
          referenceNumber: "",
          status: 2
        },
        {
          paymentId: 6,
          house: "101",
          ownerName: "John Doe",
          category: "Agua",
          createdDate: "2025-08-15",
          balance: 500,
          referenceNumber: "",
          status: 2
        },
        {
          paymentId: 7,
          house: "101",
          ownerName: "John Doe",
          category: "Mantenimiento",
          createdDate: "2025-08-16",
          balance: 500,
          referenceNumber: "",
          status: 2
        },
      ]
    },
    error: {
      message: "No se encontraron pagos",
      code: "NO_PAYMENTS",
      statusCode: 404
    }
  },
  // New admin/all payments mock
  fetchPayments: {
    success: {
      payments: [
        {
          paymentId: 1,
          house: "101",
          ownerName: "John Doe",
          category: "Mantenimiento",
          createdDate: "2025-08-01",
          balance: 1200,
          referenceNumber: "000001",
          status: 1
        },
        {
          paymentId: 2,
          house: "102",
          ownerName: "Jane Smith",
          category: "Agua",
          createdDate: "2025-08-10",
          balance: 350,
          referenceNumber: "000002",
          status: 0
        },
        {
          paymentId: 3,
          house: "103",
          ownerName: "Carlos Slim",
          category: "Luz",
          createdDate: "2025-08-15",
          balance: 500,
          referenceNumber: "",
          status: 2
        },
        {
          paymentId: 4,
          house: "101",
          ownerName: "John Doe",
          category: "Mantenimiento",
          createdDate: "2025-08-01",
          balance: 1200,
          referenceNumber: "000004",
          status: 1
        },
        {
          paymentId: 5,
          house: "104",
          ownerName: "Jeff Bezos",
          category: "Mantenimiento",
          createdDate: "2025-08-15",
          balance: 500,
          referenceNumber: "",
          status: 2
        },
        {
          paymentId: 6,
          house: "105",
          ownerName: "Elon Musk",
          category: "Agua",
          createdDate: "2025-08-15",
          balance: 500,
          referenceNumber: "",
          status: 2
        },
        {
          paymentId: 7,
          house: "106",
          ownerName: "Bill Gates",
          category: "Mantenimiento",
          createdDate: "2025-08-16",
          balance: 500,
          referenceNumber: "",
          status: 0
        },
        {
          paymentId: 8,
          house: "107",
          ownerName: "Juan Perez",
          category: "Amenidades",
          createdDate: "2025-09-16",
          balance: 200,
          referenceNumber: "",
          status: 0
        },
        {
          paymentId: 9,
          house: "109",
          ownerName: "Maria Lopez",
          category: "Extraordinario",
          createdDate: "2025-09-01",
          balance: 2000,
          referenceNumber: "",
          status: 0
        },
        {
          paymentId: 10,
          house: "107",
          ownerName: "Juan Perez",
          category: "Amenidades",
          createdDate: "2025-09-16",
          balance: 200,
          referenceNumber: "",
          status: 0
        },
        {
          paymentId: 11,
          house: "109",
          ownerName: "Maria Lopez",
          category: "Extraordinario",
          createdDate: "2025-09-01",
          balance: 2000,
          referenceNumber: "",
          status: 0
        },
        {
          paymentId: 12,
          house: "107",
          ownerName: "Juan Perez",
          category: "Amenidades",
          createdDate: "2025-09-16",
          balance: 200,
          referenceNumber: "",
          status: 0
        },
        {
          paymentId: 13,
          house: "109",
          ownerName: "Maria Lopez",
          category: "Extraordinario",
          createdDate: "2025-09-01",
          balance: 2000,
          referenceNumber: "",
          status: 0
        }
      ]
    },
    error: {
      message: "No se encontraron pagos",
      code: "NO_PAYMENTS",
      statusCode: 404
    }
  },
  createPayment: {
    success: {
      payment: {
        paymentId: 8,
        category: "Mantenimiento",
        createdDate: "2025-08-29",
        balance: 1200,
        referenceNumber: "000008",
        status: 0
      }
    },
    error: {
      message: "Error al crear el pago",
      code: "CREATE_PAYMENT_ERROR",
      statusCode: 500
    }
  }
};

// --- House Owners Mock Data ---
mockApiData.ownerApi = {
  fetchOwners: {
    success: {
      owners: [
        { ownerId: 1, name: "Owner 1", email: "owner1@example.com", phone: "+521234567800", houseNumber: "100", suburb: "Downtown", moroso: false },
        { ownerId: 2, name: "Owner 2", email: "owner2@example.com", phone: "+521234567801", houseNumber: "101", suburb: "Downtown", moroso: false },
        { ownerId: 3, name: "Owner 3", email: "owner3@example.com", phone: "+521234567802", houseNumber: "102", suburb: "Downtown", moroso: false },
        { ownerId: 4, name: "Owner 4", email: "owner4@example.com", phone: "+521234567803", houseNumber: "103", suburb: "Downtown", moroso: false },
        { ownerId: 5, name: "Owner 5", email: "owner5@example.com", phone: "+521234567804", houseNumber: "104", suburb: "Downtown", moroso: false },
        { ownerId: 6, name: "Owner 6", email: "owner6@example.com", phone: "+521234567805", houseNumber: "105", suburb: "Uptown", moroso: false },
        { ownerId: 7, name: "Owner 7", email: "owner7@example.com", phone: "+521234567806", houseNumber: "106", suburb: "Uptown", moroso: false },
        { ownerId: 8, name: "Owner 8", email: "owner8@example.com", phone: "+521234567807", houseNumber: "107", suburb: "Uptown", moroso: false },
        { ownerId: 9, name: "Owner 9", email: "owner9@example.com", phone: "+521234567808", houseNumber: "108", suburb: "Uptown", moroso: false },
        { ownerId: 10, name: "Owner 10", email: "owner10@example.com", phone: "+521234567809", houseNumber: "109", suburb: "Uptown", moroso: false },
        { ownerId: 11, name: "Moroso 1", email: "moroso1@example.com", phone: "+521234567900", houseNumber: "110", suburb: "Downtown", moroso: true },
        { ownerId: 12, name: "Moroso 2", email: "moroso2@example.com", phone: "+521234567901", houseNumber: "111", suburb: "Downtown", moroso: true },
        { ownerId: 13, name: "Moroso 3", email: "moroso3@example.com", phone: "+521234567902", houseNumber: "112", suburb: "Downtown", moroso: true },
        { ownerId: 14, name: "Moroso 4", email: "moroso4@example.com", phone: "+521234567903", houseNumber: "113", suburb: "Uptown", moroso: true },
        { ownerId: 15, name: "Moroso 5", email: "moroso5@example.com", phone: "+521234567904", houseNumber: "114", suburb: "Uptown", moroso: true },
        { ownerId: 16, name: "Owner 11", email: "owner11@example.com", phone: "+521234568000", houseNumber: "120", suburb: "Downtown", moroso: false },
        { ownerId: 17, name: "Owner 12", email: "owner12@example.com", phone: "+521234568001", houseNumber: "121", suburb: "Uptown", moroso: false },
        { ownerId: 18, name: "Owner 13", email: "owner13@example.com", phone: "+521234568002", houseNumber: "122", suburb: "Downtown", moroso: false },
        { ownerId: 19, name: "Owner 14", email: "owner14@example.com", phone: "+521234568003", houseNumber: "123", suburb: "Uptown", moroso: false },
        { ownerId: 20, name: "Owner 15", email: "owner15@example.com", phone: "+521234568004", houseNumber: "124", suburb: "Downtown", moroso: false }
      ]
    },
    error: {
      message: "No se encontraron propietarios",
      code: "NO_OWNERS",
      statusCode: 404
    }
  },
  createOwner: async (ownerData) => {
    await simulateApiDelay(300);
    const newOwner = {
      ...ownerData,
      ownerId: Date.now(),
      createdAt: new Date().toISOString()
    };
    return createApiResponse({ owner: newOwner });
  },
  updateOwner: async (ownerData) => {
    await simulateApiDelay(300);
    return createApiResponse({ owner: ownerData });
  },
  deleteOwner: async (ownerId) => {
    await simulateApiDelay(300);
    return createApiResponse({ success: true, message: "Owner deleted successfully" });
  }
};

// Mock API functions
export const mockApiCalls = {
  // Authentication
  login: async (credentials) => {
    await simulateApiDelay(800);
    if (credentials.email === "user.demo@gmail.com" && credentials.password === "user.demo") {
      return createApiResponse(mockApiData.auth.login.success);
    }
    if (credentials.email === "admin.demo@gmail.com" && credentials.password === "admin.demo") {
      return createApiResponse(mockApiData.auth.loginAdmin.success);
    }
    throw new Error(JSON.stringify(mockApiData.auth.login.error));
  },

  register: async (userData) => {
    await simulateApiDelay(1000);
    return createApiResponse(mockApiData.auth.register.success);
  },

  getProfile: async () => {
    await simulateApiDelay(500);
    
    // Check which user is logged in based on the token
    const token = localStorage.getItem('token');
    if (token && token.includes('admin')) {
      // Return admin profile if admin token
      return createApiResponse(mockApiData.auth.loginAdmin.success);
    } else if (token) {
      // Return regular user profile
      return createApiResponse(mockApiData.auth.getProfile.success);
    } else {
      // No token, return error
      throw new Error(JSON.stringify({
        message: "No valid token found",
        code: "INVALID_TOKEN",
        statusCode: 401
      }));
    }
  },

  getVisitorsByHome: async (homeNumber) => {
    await simulateApiDelay(800);
    return createApiResponse(mockApiData.visitorApi.getVisitorsByHome.success);
  },

  //visitor Api
  createVisitor: async (visitor) => {
    await simulateApiDelay(600);
    return createApiResponse(mockApiData.visitorApi.createVisitor.success);
  },

  getVisitorByGuid: async (guid) => {
    await simulateApiDelay(600);
    return createApiResponse(mockApiData.visitorApi.getVisitorByGuid.success);
  },

  getAnnouncements: async (limit = 20) => {
    await simulateApiDelay(600);
    return createApiResponse(mockApiData.announcements.slice(0, limit));
  },

  // Fetch Testimonials from Api
  getTestimonials: async (limit = 10) => {
    await simulateApiDelay(600);
    return createApiResponse(mockApiData.testimonials.slice(0, limit));
  },

  //Amenities Api
  getAmenitiesByHome: async () => {
    await simulateApiDelay(600);
    return createApiResponse(mockApiData.amenitiesApi.getAmenitiesByHome);
  },

  getAmenitiesPreferences: async () => {
    await simulateApiDelay(600);
    return createApiResponse(mockApiData.amenitiesApi.getAmenitiesPreferences.amenities);
  },

  getReservedAmenitiesByType: async (type) => {
    await simulateApiDelay(600);
    if(type === 'Alberca'){
      return createApiResponse(mockApiData.amenitiesApi.getReservedAmenitiesByType[0]);
    }
    else{
      return createApiResponse(mockApiData.amenitiesApi.getReservedAmenitiesByType[1]);
    }
  },

  getAllReservations: async () => {
    await simulateApiDelay(600);
    return createApiResponse(mockApiData.amenitiesApi.reservations);
  },

  reserveAmenity: async (amenityRequest) => {
    await simulateApiDelay(600);
    return createApiResponse(mockApiData.amenitiesApi.reserveAmenity);
  },

  // Amenities CRUD
  createAmenity: async (amenity) => {
    await simulateApiDelay(300);
    const newAmenity = {
      ...amenity,
      id: Date.now(), // Mock ID generation
      createdAt: new Date().toISOString()
    };
    return createApiResponse(newAmenity);
  },

  updateAmenity: async (amenity) => {
    await simulateApiDelay(300);
    return createApiResponse(amenity);
  },

  deleteAmenity: async (id) => {
    await simulateApiDelay(300);
    return createApiResponse({ success: true, message: 'Amenity deleted successfully' });
  },

  // Reservations CRUD
  createReservation: async (reservation) => {
    await simulateApiDelay(800);
    const newReservation = {
      ...reservation,
      id: Date.now(), // Mock ID generation
      createdAt: new Date().toISOString(),
      status: 0 // Default to pending
    };
    return createApiResponse(newReservation);
  },

  updateReservation: async (reservation) => {
    await simulateApiDelay(700);
    return createApiResponse(reservation);
  },

  deleteReservation: async (id) => {
    await simulateApiDelay(500);
    return createApiResponse({ success: true, message: 'Reservation deleted successfully' });
  },

  approveReservation: async (id) => {
    await simulateApiDelay(200);
    return createApiResponse({ success: true, message: 'Reservation approved' });
  },

  rejectReservation: async (id) => {
    await simulateApiDelay(200);
    return createApiResponse({ success: true, message: 'Reservation rejected' });
  },

  //pricing
  getPricing: async () => {
    await simulateApiDelay(400);
    return createApiResponse(mockApiData.pricing);
  },

  getBlogPosts: async (page = 1, limit = 10) => {
    await simulateApiDelay(700);
    return createApiResponse({
      posts: mockApiData.blog,
      pagination: {
        page,
        limit,
        total: mockApiData.blog.length,
        totalPages: Math.ceil(mockApiData.blog.length / limit)
      }
    });
  },

  getFaqs: async () => {
    await simulateApiDelay(300);
    return createApiResponse(mockApiData.faqs);
  },

  getFeatures: async () => {
    await simulateApiDelay(400);
    return createApiResponse(mockApiData.features);
  },

  getStats: async () => {
    await simulateApiDelay(500);
    return createApiResponse(mockApiData.stats);
  },

  // Form submissions
  submitContact: async (formData) => {
    await simulateApiDelay(1200);
    return createApiResponse(mockApiData.contact.submit.success);
  },

  subscribeNewsletter: async (email) => {
    await simulateApiDelay(800);
    return createApiResponse(mockApiData.newsletter.subscribe.success);
  }
  ,
  // --- Payment API Calls ---
  getPaymentsByHome: async (homeNumber) => {
    await simulateApiDelay(900);
    return createApiResponse(mockApiData.paymentApi.getPaymentsByHome.success);
  },
  createPayment: async (payments) => {
    await simulateApiDelay(600);
    return createApiResponse(mockApiData.paymentApi.createPayment.success);
  },
  fetchAllPayments: async () => {
    await simulateApiDelay(700);
    return createApiResponse(mockApiData.paymentApi.fetchPayments.success);
  },
  fetchOwners: async () => {
    await simulateApiDelay(300);
    return createApiResponse(mockApiData.ownerApi.fetchOwners.success);
  },
  createOwner: async (ownerData) => {
    await simulateApiDelay(300);
    const newOwner = {
      ...ownerData,
      ownerId: Date.now(),
      createdAt: new Date().toISOString()
    };
    return createApiResponse({ owner: newOwner });
  },
  updateOwner: async (ownerData) => {
    await simulateApiDelay(300);
    return createApiResponse({ owner: ownerData });
  },
  deleteOwner: async (ownerId) => {
    await simulateApiDelay(300);
    return createApiResponse({ success: true, message: "Owner deleted successfully" });
  },

  // Accounting Operations CRUD
  createOperation: async (operation) => {
    await simulateApiDelay(300);
    const newOperation = {
      ...operation,
      id: Date.now(),
      createdAt: new Date().toISOString()
    };
    return createApiResponse(newOperation);
  },

  updateOperation: async (operation) => {
    await simulateApiDelay(300);
    return createApiResponse(operation);
  },

  deleteOperation: async (id) => {
    await simulateApiDelay(300);
    return createApiResponse({ success: true, message: 'Operation deleted successfully' });
  },

  // Periods CRUD
  createPeriod: async (period) => {
    await simulateApiDelay(300);
    const newPeriod = {
      ...period,
      id: Date.now(),
      status: "open"
    };
    return createApiResponse(newPeriod);
  },

  updatePeriod: async (period) => {
    await simulateApiDelay(300);
    return createApiResponse(period);
  },

  archivePeriod: async (id) => {
    await simulateApiDelay(300);
    return createApiResponse({ success: true, message: 'Period archived successfully' });
  },

  // Categories CRUD
  fetchCategoryOptions: async () => {
    await simulateApiDelay(300);
    const mockCategoryOptions = [
      {
        id: 1, options: [
          { id: 1, name: "Mantenimiento" },
          { id: 2, name: "Amenidades" },
          { id: 3, name: "Servicios Externos" },
          { id: 4, name: "Multas" },
          { id: 5, name: "Extraordinario" },
          { id: 6, name: "Vigilancia" },
          { id: 7, name: "Salarios" },
          { id: 8, name: "Otros" }
        ]
      },
      {
        id: 2, options: [
          { id: 1, name: "Mantenimiento" },
          { id: 2, name: "Amenidades" },
          { id: 3, name: "Extraordinario" }
        ]
      }
    ];
    return createApiResponse(mockCategoryOptions);
  },

  createCategory: async ({ catalogId, name }) => {
    await simulateApiDelay(300);
    const newCategory = {
      id: Date.now(),
      name,
      catalogId
    };
    return createApiResponse(newCategory);
  },

  updateCategory: async ({ catalogId, categoryId, name }) => {
    await simulateApiDelay(300);
    return createApiResponse({ catalogId, categoryId, name });
  },

  deleteCategory: async ({ catalogId, categoryId }) => {
    await simulateApiDelay(300);
    return createApiResponse({ success: true, message: 'Category deleted successfully' });
  },

  createCatalog: async () => {
    await simulateApiDelay(300);
    const newCatalog = {
      id: Date.now(),
      options: []
    };
    return createApiResponse(newCatalog);
  },

  // Fraccionamientos CRUD
  addFracc: async (fracc) => {
    await simulateApiDelay(300);
    const preserves = fracc.amenities && fracc.amenities.length > 0 ? fracc.amenities.join(", ") : "";
    const newFracc = {
      ...fracc,
      id: Date.now(),
      preserves,
      createdAt: new Date().toISOString()
    };
    return createApiResponse(newFracc);
  },

  updateFracc: async (fracc) => {
    await simulateApiDelay(300);
    const preserves = fracc.amenities && fracc.amenities.length > 0 ? fracc.amenities.join(", ") : "";
    return createApiResponse({ ...fracc, preserves });
  },

  deleteFracc: async (id) => {
    await simulateApiDelay(300);
    return createApiResponse({ success: true, message: 'Fraccionamiento deleted successfully' });
  }
};

// ---------------------------------------------------------------------------
// InvitationApi Mock Data
// Static scenarios referenced by mockApiCalls invitation functions below.
// TEST SCENARIO URLS - paste these in the browser to test each UI state:
//   /invitacion/a1000001-0000-0000-0000-000000000001 -> NotActivated, OTP enabled (happy path)
//   /invitacion/a1000002-0000-0000-0000-000000000002 -> NotActivated, OTP disabled (auto-QR)
//   /invitacion/a1000003-0000-0000-0000-000000000003 -> NeedsReactivation (browser closed)
//   /invitacion/a1000004-0000-0000-0000-000000000004 -> CanReactivate (multi-entry)
//   /invitacion/a1000005-0000-0000-0000-000000000005 -> Completed (terminal)
//   /invitacion/a1000006-0000-0000-0000-000000000006 -> Expired (terminal)
//   /invitacion/a1000007-0000-0000-0000-000000000007 -> Cancelled (terminal)
//   Any unknown GUID                                 -> defaults to Scenario 1
// ---------------------------------------------------------------------------
const invitationMockData = {
  scenarios: {
    notActivated_otpEnabled: {
      invitationGuid: "a1000001-0000-0000-0000-000000000001",
      invitationState: "NotActivated",
      visitorName: "Carlos Rodríguez",
      homeownerName: "Familia García",
      startDate: "2026-07-25",
      endDate: "2026-07-26",
      accessWindowStart: "09:00",
      accessWindowEnd: "20:00",
      remainingEntries: 1,
      unlimitedAccess: false,
      maxOpenDoorTimes: 1,
      otpVerificationEnabled: true,
      notes: "Visita familiar - acceso principal"
    },
    notActivated_otpDisabled: {
      invitationGuid: "a1000002-0000-0000-0000-000000000002",
      invitationState: "NotActivated",
      visitorName: "Ana Martínez",
      homeownerName: "Familia López",
      startDate: "2026-07-25",
      endDate: "2026-07-25",
      accessWindowStart: "10:00",
      accessWindowEnd: "18:00",
      remainingEntries: 1,
      unlimitedAccess: false,
      maxOpenDoorTimes: 1,
      otpVerificationEnabled: false,
      notes: "Proveedor - servicio de jardinería"
    },
    needsReactivation: {
      invitationGuid: "a1000003-0000-0000-0000-000000000003",
      invitationState: "NeedsReactivation",
      visitorName: "Roberto Sánchez",
      homeownerName: "Familia Torres",
      startDate: "2026-07-25",
      endDate: "2026-07-25",
      accessWindowStart: "08:00",
      accessWindowEnd: "22:00",
      remainingEntries: 1,
      unlimitedAccess: false,
      maxOpenDoorTimes: 1,
      otpVerificationEnabled: true,
      notes: "Activó el QR antes pero cerró la app"
    },
    canReactivate: {
      invitationGuid: "a1000004-0000-0000-0000-000000000004",
      invitationState: "CanReactivate",
      visitorName: "María López",
      homeownerName: "Familia Hernández",
      startDate: "2026-07-20",
      endDate: "2026-07-31",
      accessWindowStart: "07:00",
      accessWindowEnd: "21:00",
      remainingEntries: 2,
      unlimitedAccess: false,
      maxOpenDoorTimes: 3,
      otpVerificationEnabled: true,
      notes: "Inquilina con acceso semanal"
    },
    completed: {
      invitationGuid: "a1000005-0000-0000-0000-000000000005",
      invitationState: "Completed",
      visitorName: "Pedro Jiménez",
      homeownerName: "Familia Ruiz",
      startDate: "2026-07-24",
      endDate: "2026-07-24",
      remainingEntries: 0,
      unlimitedAccess: false,
      maxOpenDoorTimes: 1,
      otpVerificationEnabled: true,
      notes: "Visita usada completamente"
    },
    expired: {
      invitationGuid: "a1000006-0000-0000-0000-000000000006",
      invitationState: "Expired",
      visitorName: "Laura González",
      homeownerName: "Familia Morales",
      startDate: "2026-07-01",
      endDate: "2026-07-10",
      remainingEntries: null,
      unlimitedAccess: false,
      maxOpenDoorTimes: 1,
      otpVerificationEnabled: true,
      notes: "Fecha de acceso ya venció"
    },
    cancelled: {
      invitationGuid: "a1000007-0000-0000-0000-000000000007",
      invitationState: "Cancelled",
      visitorName: "Fernando Castro",
      homeownerName: "Familia Vargas",
      startDate: "2026-07-25",
      endDate: "2026-07-26",
      remainingEntries: null,
      unlimitedAccess: false,
      maxOpenDoorTimes: 1,
      otpVerificationEnabled: true,
      notes: "El propietario canceló la invitación"
    }
  },
  // TOTP seed delivered once on activation (never stored in localStorage)
  // SECURITY: In production this is AES-256 encrypted at rest; delivered once over HTTPS
  activationSeed: "JBSWY3DPEHPK3PXP"
};

// ---------------------------------------------------------------------------
// InvitationApi Mock Calls - added to mockApiCalls below
// Architecture ref: docs/AI_INTEGRATION_INSTRUCTIONS.md section 3.0b, 3.1, 3.2
// ---------------------------------------------------------------------------
// NOTE: mockApiCalls is declared at the top of this section and continues here.
// The invitation functions are appended to it via Object.assign after declaration.

Object.assign(mockApiCalls, {
  /**
   * Mock for GET /api/invitations/{guid}
   * Routes to the matching scenario by GUID; unknown GUIDs fall back to happy-path.
   */
  getInvitationByGuid: async (guid) => {
    await simulateApiDelay(600);

    // ── HAPPY PATH (active) ───────────────────────────────────────────────
    const scenarios = invitationMockData.scenarios;
    const matched = Object.values(scenarios).find(s => s.invitationGuid === guid);
    if (matched) return createApiResponse(matched);
    return createApiResponse(scenarios.notActivated_otpEnabled);

    /* ── FAILURE SCENARIOS (uncomment one at a time to test) ─────────────
    // 404 — Invitation not found (bad or expired link):
    // throw new Error("INVITATION_NOT_FOUND");
    */
  },

  /**
   * Mock for POST /api/invitations/{id}/request-otp
   * In production this calls WhatsApp Business API or Telnyx SMS.
   * Mock always succeeds; any 6-digit code is accepted in activateInvitation below.
   */
  requestOtp: async (invitationGuid) => {
    await simulateApiDelay(800);

    // ── HAPPY PATH (active) ───────────────────────────────────────────────
    return createApiResponse({ message: "OTP sent to the registered phone number." });

    /* ── FAILURE SCENARIOS (uncomment one at a time to test) ─────────────
    // 409 — OTP already sent (not yet expired, prevent spam):
    // throw new Error("OTP_ALREADY_SENT");

    // 429 — Rate limited (> 3 requests per 10 min per invitation):
    // throw new Error("OTP_RATE_LIMITED");

    // 404 — Invitation not found:
    // throw new Error("INVITATION_NOT_FOUND");
    */
  },

  /**
   * Mock for POST /api/invitations/{id}/activate
   * Any 6-digit OTP is accepted in mock mode.
   * Returns the TOTP secret seed — caller MUST keep it only in component state.
   */
  activateInvitation: async (invitationGuid, otpCode) => {
    await simulateApiDelay(900);

    // ── HAPPY PATH (active) ───────────────────────────────────────────────
    const scenarios = invitationMockData.scenarios;
    const matched   = Object.values(scenarios).find(s => s.invitationGuid === invitationGuid);
    const visitorName = matched?.visitorName ?? "Visitante Demo";
    const validUntil  = matched?.endDate
      ? `${matched.endDate}T${matched.accessWindowEnd ?? "23:59"}:00Z`
      : "2026-07-31T23:59:00Z";

    return createApiResponse({
      totpSecretSeed: invitationMockData.activationSeed,
      invitationGuid,
      visitorName,
      validUntil,
    });

    /* ── FAILURE SCENARIOS (uncomment one at a time to test) ─────────────
    // 401 — Invalid or expired OTP code:
    // throw new Error("INVALID_OTP");

    // 409 — Invitation already activated:
    // throw new Error("ALREADY_ACTIVATED");

    // 410 — Invitation was cancelled by the homeowner:
    // throw new Error("INVITATION_CANCELLED");
    */
  },

  /**
   * Mock for POST /api/invitations (homeowner creates a new invitation).
   * Returns a generated GUID and shareable URL.
   */
  createInvitation: async (invitationData) => {
    await simulateApiDelay(700);

    // ── HAPPY PATH (active) ───────────────────────────────────────────────
    const newGuid = `a1${Date.now().toString(16).slice(-6)}-mock-4000-8000-${Math.random().toString(16).slice(2, 14)}`;
    const baseUrl = (process.env.REACT_APP_BASE_URL || "http://localhost:3000/");
    return createApiResponse({
      visitorId: Date.now(),
      invitationGuid: newGuid,
      visitorName:    invitationData?.visitorName    ?? "Visitante",
      status:         "Registered",
      statusId:       1,
      invitationUrl:  `${baseUrl}invitacion/${newGuid}`,
    });

    /* ── FAILURE SCENARIOS (uncomment one at a time to test) ─────────────
    // 400 — Invalid phone number format:
    // throw new Error("INVALID_INVITATION_DATA");

    // 403 — Homeowner subscription inactive:
    // throw new Error("NOT_AUTHORIZED");
    */
  },

  /**
   * Mock for DELETE /api/invitations/{guid} (homeowner cancels).
   */
  cancelInvitation: async (invitationGuid) => {
    await simulateApiDelay(500);

    // ── HAPPY PATH (active) ───────────────────────────────────────────────
    return createApiResponse({ success: true, message: "Invitation cancelled successfully." });

    /* ── FAILURE SCENARIOS (uncomment one at a time to test) ─────────────
    // Invitation not found:
    // throw new Error("INVITATION_NOT_FOUND");
    */
  }
});

